import { useState, type FC } from 'react';
import cx from 'classnames';
import { Radio, Space, Text } from '@g2u/ui-kit';

import { Condition, type JsonDataItem, type WithOptionalDataTest } from 'types';
import { InputName, InputPhone, Section } from 'components';
import { useText } from 'helpers/hooks/useText';
import styles from './secondary-contact-fields.module.scss';

type Props = {
  hasScript?: boolean;
  inline?: boolean;
  customer: JsonDataItem | null;
} & WithOptionalDataTest;

export const SecondaryContactFields: FC<Props> = (props) => {
  const { inline, customer, hasScript } = props;
  const [showFields, setShowFields] = useState<string>(customer?.second_contact || Condition.No);
  const { getText } = useText();

  return (
    <Section title="Secondary Contact" inline={inline}>
      <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
        {hasScript && <Text.$ className="script-box">{getText('booking.start.addSecondPerson')}</Text.$>}
        <Space.$
          direction={Space.Direction.Vertical}
          size={Space.Size.Middle}
          className={styles.secondaryContact__formItem_horizontal}
        >
          <Radio.$
            required
            dataTestId="secondary-contact"
            initialValue={customer?.second_contact || Condition.No}
            name="secondaryContact"
            onChange={(e) => {
              setShowFields(e.target.value);
            }}
            options={[
              {
                label: <>Yes</>,
                value: Condition.Yes,
              },
              {
                label: <>No</>,
                value: Condition.No,
              },
            ]}
          />

          {showFields === Condition.Yes && (
            <Space.$
              direction={Space.Direction.Vertical}
              size={Space.Size.Small}
              className={styles.secondaryContact__contactForm}
            >
              <div className={styles.secondaryContact__formRow}>
                <InputName
                  label="First Name:"
                  dataTestId="secondary-first-name"
                  name="secondaryFirstName"
                  className={cx(styles.secondaryContact__formItem_vertical, styles.secondaryContact__contactFormItem)}
                  initialValue={customer?.name.contact2_firstname}
                  required={true}
                />
                <InputName
                  label="Last Name:"
                  dataTestId="secondary-last-name"
                  name="secondaryLastName"
                  className={cx(styles.secondaryContact__formItem_vertical, styles.secondaryContact__contactFormItem)}
                  initialValue={customer?.name.contact2_surname}
                  required={true}
                />
              </div>
              <div className={styles.secondaryContact__formRow}>
                <InputPhone
                  label="Mobile Number:"
                  dataTestId="secondary-mobile-number"
                  name="secondaryMobileNumber"
                  className={cx(styles.secondaryContact__formItem_vertical, styles.secondaryContact__contactFormItem)}
                  initialValue={customer?.contact2.contact2_mobile}
                  required={false}
                />
              </div>
            </Space.$>
          )}
        </Space.$>
      </Space.$>
    </Section>
  );
};
